export const ROOT_ID = "irobot-embedded-quiz-v4";

export default {
  ROOT_ID,
};
